import React, { useState } from "react";
import { SeatsioSeatingChart } from "@seatsio/seatsio-react";

import { SelectedTickets } from "../SelectedTickets";
import NewLoader from "../../../components/NewLoader/NewLoader";
import { TicketsPicker } from "../TicketsPicker";

import "../OpenSell.sass";
import { getCurrentLanguageTexts } from "../../../constants/seasonPassPersonalInfoLangs";
import { getActivatedRules } from "../../../helpers/paymentHelper/paymentHelper.ts";
import { seatsIoObjectToTicket } from "../../../helpers/ticketHelper.ts";

export const SelectTickets = ({
  tickets,
  setCouponHandler,
  coupon,
  total,
  ticketTemplates,
  onObjectSelected,
  currency,
  pricing,
  onObjectDeselected,
  administrativeFee,
  processingFee = 0,
  paymentMethodSelected = false,
  loading,
  workspaceKey,
  eventSeatsId,
  event,
  isOffers,
  maxSelectedObjects = 4,
  hasSeats,
  channels = ['NO_CHANNEL'],
  offers = [],
  showInfo = false,
  reservations = [],
  multiSelectEnabled = false,
  onSetChart = (chart) => null,
  allowEnterCouponCode = true,
  allowManualDiscount = false,
  manualDiscount = 0,
  setManualDiscount = () => null,
  popupMode = false,
  theme = null,
  isTermsChecked,
  handleChangeCheckbox,
  showTermsAndConditionsModal,
  isTermsCheckbox = true,
  isNextStepLoading = false,
  allowSelectNfc = false,
  allowAddTicket = () => null
}) => {
  const [chart, setChart] = useState(null);
  const txt = getCurrentLanguageTexts();
  const [isMapLoading, setMapLoading] = useState(true);
  const [isDiscountsOpen, setIsDiscountsOpen] = useState(false);

  const onChartRendered = async (c) => {
    onSetChart(c);
    setChart(c);
    setMapLoading(false);
    allowAddTicket();
  }

  const renderSelectSection = () => {
    switch (hasSeats) {
      case false:
        return (
          <TicketsPicker
            canSelect={
              tickets.reduce((num, item) => num + 1, 0) <
              (maxSelectedObjects)
            }
            onObjectSelected={onObjectSelected}
            onObjectDeselected={onObjectDeselected}
            ticketTemplates={ticketTemplates}
            currency={currency}
            tickets={tickets}
          />
        );
      case true:

        const onSeatSelected = async (params) => {
          onObjectSelected(params);
        }

        return (
          <SeatsioSeatingChart
            channels={channels}
            maxSelectedObjects={maxSelectedObjects}
            pricing={pricing}
            session="continue"
            priceFormatter={(price) => `${price} ${currency}`}
            onChartRendered={c => onChartRendered(c)}
            onObjectSelected={o => onSeatSelected(seatsIoObjectToTicket(o, pricing))}
            onObjectDeselected={o => onObjectDeselected(seatsIoObjectToTicket(o, pricing))}
            workspaceKey={workspaceKey}
            event={eventSeatsId}
            region="eu"
            multiSelectEnabled={multiSelectEnabled}
            objectWithoutPricingSelectable={false}
            tooltipInfo={(o) => {
              if (!showInfo) {
                return
              }

              const isOfferChannel = reservations.some(r => r.label === 'Offers' && o.isInChannel(r.channelKey));

              let info = '';

              info += `${reservations.reduce((a, i) => {
                return a + ((o.status == 'free' && o.isInChannel(i.channelKey)) ? `[b]${i.label}[/b][br/]` : ``);
              }, '')}`

              if (info) {
                info += '[br/]'
              }

              if (o.extraData) {
                if ('email' in o.extraData) {
                  info += `${o.extraData.email}[br/]`
                }

                if ('transaction_payment_type' in o.extraData) {
                  const type = o.extraData.transaction_payment_type;
                  info += `[b]${false
                    || type == 1 && 'Online'
                    || type == 2 && 'By cash'
                    || type == 3 && 'By pin'
                    || type == 4 && 'As generated'
                    || type == 5 && 'As guest'
                    || type == 6 && 'By invoice'
                    || type == 7 && 'Uploaded'
                    || ''
                    }[/b][br/]`
                }

                if ('ticket_type' in o.extraData) {
                  const type = o.extraData.ticket_type;
                  info += `[b]${type}[/b][br/]`
                }
              }
              else if (isOfferChannel) {
                const offer = offers.find(of => of.seatLabel === o.label);
                if (offer) {
                  info += `[b]Offered to:[/b] ${offer.fullName}[br/]${offer.email} `
                }
              }

              return info
            }
            }
          />
        );
      default:
        return null;
    }
  };

  if (isOffers) {
    return (
      <div className="partizan-open-selling__step-info">
        {loading ? (
          <div style={{ height: "550px" }}>
            <NewLoader />
          </div>
        ) : (
          <SelectedTickets
            hasSeats={hasSeats}
            administrativeFee={administrativeFee}
            processingFee={processingFee}
            paymentMethodSelected={paymentMethodSelected}
            tickets={tickets}
            currency={currency}
            total={total}
            event={event}
            mixedTickets={true}
            setCouponHandler={setCouponHandler}
            allowEnterCouponCode={allowEnterCouponCode}
            coupon={coupon}
            theme={theme}
            isTermsChecked={isTermsChecked}
            handleChangeCheckbox={handleChangeCheckbox}
            showTermsAndConditionsModal={showTermsAndConditionsModal}
            isTermsCheckbox={isTermsCheckbox}
            isOfferPage={true}
          />
        )}
      </div>
    );
  }


  const activatedRules = getActivatedRules(tickets, ticketTemplates);

  return (
    <div className="partizan-open-selling__step partizan-open-selling__select-tickets">
      <div className={`partizan-open-selling__step-hero ${popupMode ? 'select-ticket-popup-mode' : ''}`}>
        {event.description && event.description.length > 4 && (<>
          <div className="partizan-open-selling__event-description" dangerouslySetInnerHTML={{ __html: event.description }}>
          </div>
        </>)}
        <h4 className="partizan-open-selling__text-bold">
          {hasSeats ? txt.sellPageTxt.chooseYourSeatOnMap : txt.sellPageTxt.tickets}
        </h4>
        <div className={`partizan-open-selling__select-section ${hasSeats ? "partizan-open-selling__select-section_no-scroll" : ""}`}>
          {renderSelectSection()}
        </div>
      </div>
      <div className={`partizan-open-selling__step-info ${popupMode ? 'select-ticket-popup-mode' : ''}`}>

        {ticketTemplates.flatMap(t => t.ticketRules).length > 0
          && <div className={`partizan-open-selling__rules ${isDiscountsOpen ? 'open' : ''}`}>
            <div className="title"
              onClick={() => setIsDiscountsOpen(v => !v)}>
              <p>{txt.sellPageTxt['DISCOUNTS']}</p>
            </div>
            <div className="rule-list">
              {ticketTemplates.flatMap(t => t.ticketRules).map(i => <div className={`rule-item ${!!activatedRules.find(r => r.id === i.id) ? 'active' : ''}`}>
                <p>{txt.sellPageTxt.getRuleTitle(ticketTemplates.find(tt => tt.ticketTemplateId === i.ticketTemplateId).name, i.count)}</p>

                <>{i.type === 1 && <p>{txt.sellPageTxt.getRuleEffectCount(i.price.toFixed(2), currency)}</p>
                  || i.type === 2 && <p>{txt.sellPageTxt.getRuleEffectPercent(i.price)}</p>}</>
              </div>)}
            </div>
          </div>
        }
        {isNextStepLoading && (
          <div className="partizan-open-selling__support-loader">
            <NewLoader />
          </div>
        )}
        <SelectedTickets
          hasSeats={hasSeats}
          administrativeFee={administrativeFee}
          processingFee={processingFee}
          paymentMethodSelected={paymentMethodSelected}
          tickets={tickets}
          currency={currency}
          total={total}
          event={event}
          mixedTickets={true}
          setCouponHandler={setCouponHandler}
          ticketAdd={onObjectSelected}
          ticketRemove={onObjectDeselected}
          coupon={coupon}
          allowEnterCouponCode={allowEnterCouponCode}
          allowManualDiscount={allowManualDiscount}
          manualDiscount={manualDiscount}
          setManualDiscount={setManualDiscount}
          popupMode={popupMode}
          theme={theme}
          isTermsChecked={isTermsChecked}
          handleChangeCheckbox={handleChangeCheckbox}
          showTermsAndConditionsModal={showTermsAndConditionsModal}
          isTermsCheckbox={isTermsCheckbox}
          onObjectDeselected={onObjectDeselected}
          isMapLoading={isMapLoading}
          allowSelectNfc={allowSelectNfc}
        />
      </div>
    </div>
  );
};
